// extracted by mini-css-extract-plugin
export default {"tableWrapper":"HeiClientSideGrid_tableWrapper__K6kGl"};